import DOMPurify from 'dompurify';

export const SafeQuillHtml = ({ html, testId }) => (
  <span
    data-testid={testId || 'safe-html'}
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize((html ?? '').replaceAll('&nbsp;', ' ').replaceAll('<p></p>', '<p>&nbsp;</p>')) }}
  />
);

export default SafeQuillHtml;
